class FiltersOrder {
  form: HTMLFormElement

  constructor(form: HTMLFormElement) {
    this.form = form
    this.handleSelect()
  }

  private handleSelect() {
    const select = this.form.querySelector('#filters-order-select') as HTMLSelectElement

    if (select) {
      const inputMetaKey = this.form.querySelector('[name="meta_key"]') as HTMLInputElement
      const inputOrderBy = this.form.querySelector('[name="orderby"]') as HTMLInputElement

      if (inputMetaKey && inputOrderBy) {
        select.addEventListener('click', () => {
          const selectedOption = select.options[select.selectedIndex]
          const metaKeyValue = selectedOption.getAttribute('data-meta-key')
          const orderByValue = selectedOption.getAttribute('data-order-by')

          inputMetaKey.value = `${metaKeyValue}`
          inputOrderBy.value = `${orderByValue}`
        })
      }
    }
  }
}

export default FiltersOrder
